import React from "react";
import { VALIDATION_CHECKS } from "pages/MasterPengobatanStandar/constants";

// ValidationFinding[] dari GET /version-rule/{id}/validation atau 409 release.
// `message` sudah berbahasa Indonesia dan siap tampil (openapi.yaml).
const FindingsList = ({ findings, renderAction }) =>
  findings.length ? (
    <ul className="mps-issue-list">
      {findings.map((f, i) => (
        <li key={`${f.check}-${i}`}>
          <span className="mps-pill is-error" title={VALIDATION_CHECKS[f.check]?.label}>
            {f.check}
          </span>
          <span>{f.message}</span>
          {renderAction && renderAction(f)}
        </li>
      ))}
    </ul>
  ) : (
    <p className="mps-muted mb-0">Tidak ada findings.</p>
  );

export default FindingsList;
